import type { Component } from 'vue';
import { isOfficeAddinHost } from '@/office/utils';
import AuthLayout from './AuthLayout.vue';
import DefaultLayout from './DefaultLayout.vue';
import ExternalLayout from './ExternalLayout.vue';
import OfficeAuthLayout from './OfficeAuthLayout.vue';
import OfficeLayout from './OfficeLayout.vue';

/** Layout a route opts into via `meta.layout`; absent means 'default'. */
export type LayoutName = 'auth' | 'default' | 'external';

/**
 * Maps a route's declared layout to the concrete layout component.
 * Office vs web is a runtime property of the host (the add-in visits the
 * same routes as the web app), so it is resolved here rather than in meta.
 */
export function resolveLayoutComponent(layout: LayoutName | undefined): Component {
  const officeHost = isOfficeAddinHost();
  switch (layout ?? 'default') {
    case 'auth':
      return officeHost ? OfficeAuthLayout : AuthLayout;
    case 'external':
      return ExternalLayout;
    default:
      return officeHost ? OfficeLayout : DefaultLayout;
  }
}
